"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgIssueDenomNFT = void 0;
var ow_1 = __importDefault(require("ow"));
var ow_types_1 = require("../ow.types");
var address_1 = require("../../../utils/address");
var typeurl_1 = require("../../common/constants/typeurl");
exports.msgIssueDenomNFT = function (config) {
    return (function () {
        function MsgIssueDenom(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgIssueDenomOptions);
            this.id = options.id;
            this.name = options.name;
            this.schema = options.schema;
            this.sender = options.sender;
            this.validateAddress();
        }
        MsgIssueDenom.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.nft.MsgIssueDenom,
                value: {
                    id: this.id,
                    name: this.name,
                    schema: this.schema,
                    sender: this.sender,
                },
            };
        };
        MsgIssueDenom.prototype.toRawAminoMsg = function () {
            return {
                type: 'chainmain/nft/MsgIssueDenom',
                value: {
                    id: this.id,
                    name: this.name,
                    schema: this.schema,
                    sender: this.sender,
                },
            };
        };
        MsgIssueDenom.prototype.validateAddress = function () {
            if (!address_1.validateAddress({
                address: this.sender,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `sender` does not match network selected');
            }
        };
        return MsgIssueDenom;
    }());
};
//# sourceMappingURL=MsgIssueDenom.js.map